import { cva, type VariantProps } from 'class-variance-authority';

export const bannerVariants = cva(
  'flex w-full flex-row items-center py-1.25 pl-4 pr-2.5 text-sm leading-[16.94px] mobile:text-3xs mobile:leading-3',
  {
    variants: {
      variant: {
        general: 'bg-dark-gunmetal-500 text-neutral-50',
        technical: 'bg-green-500  text-neutral-1000',
      },
    },
    defaultVariants: {
      variant: 'technical',
    },
  },
);

export type BannerVariantProps = VariantProps<typeof bannerVariants>;
